// Campo de contraseña con botón "Ver/Ocultar" — en celular, en campo, es
// muy común equivocarse al escribir y no saber por qué falla el login.
import { useState } from "react";
import { Form } from "react-bootstrap";

export default function CampoPassword({ value, onChange, ...props }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="auth-input-pass">
      <Form.Control
        type={visible ? "text" : "password"}
        value={value}
        onChange={onChange}
        {...props}
      />
      <button
        type="button"
        className="auth-ojo"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Ocultar contraseña" : "Mostrar contraseña"}
        tabIndex={-1}
      >
        {visible ? "Ocultar" : "Ver"}
      </button>
    </div>
  );
}
